import { orderCardActions } from './order-card.actions';
import { CoreAppState } from '../core-app.state';
import {
  BaseResourceState,
  createBaseResourceReducer,
  initialResourceState,
} from '../create-base-resource-reducer';
import { OrderCardResourceTypeMappings } from '@aa/nest/resource';
import { on } from '@ngrx/store';

type CardsSavingState = Record<
  OrderCardResourceTypeMappings['resourcePrimaryKeyT'],
  boolean
>;

export type OrderCardState =
  BaseResourceState<OrderCardResourceTypeMappings> & {
    cardsSaving: CardsSavingState;
  };
export const initialOrderCardState: OrderCardState = {
  ...initialResourceState,
  cardsSaving: {} as CardsSavingState,
};

export const orderCardReducer = createBaseResourceReducer<
  OrderCardResourceTypeMappings,
  OrderCardState
>(initialOrderCardState, orderCardActions, [
  on(
    orderCardActions.updateCardWithAttributes,
    (state: OrderCardState, payload) => ({
      ...state,
      cardsSaving: {
        ...state.cardsSaving,
        [payload.id]: true,
      },
    }),
  ),
  on(orderCardActions.cardUpdated, (state: OrderCardState, payload) => ({
    ...state,
    cardsSaving: {
      ...state.cardsSaving,
      [payload.id]: false,
    },
  })),
]);

export const selectOrderCardState = (state: CoreAppState) =>
  state.orderCard ?? initialOrderCardState;
